export const contactCenterHomepagePath = "/contact-center"
export const chatQueuesPath = `${contactCenterHomepagePath}/chat-queues`
export const addChatQueuePath = `${contactCenterHomepagePath}/chat-queues/new`

export const editChatQueuePath = `${contactCenterHomepagePath}/chat-queues/:queueId/edit`
export const buildEditChatQueuePath = queueId => `${contactCenterHomepagePath}/chat-queues/${queueId}/edit`
